import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68a09eaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "予約一覧", -1))
const _hoisted_3 = { class: "filters-wrapper grid" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "history-wrap grid" }
const _hoisted_7 = {
  key: 0,
  class: "col-12 grid"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "予約日", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "予約枠", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "p-card p-component"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-logo logo block" }, null, -1))
const _hoisted_13 = { class: "card-body flex flex-column" }
const _hoisted_14 = { class: "body-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-label inline-block" }, "日時", -1))
const _hoisted_16 = {
  key: 0,
  class: "row-content inline-block"
}
const _hoisted_17 = {
  key: 1,
  class: "row-content inline-block"
}
const _hoisted_18 = { class: "body-row flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-label inline-block" }, "メニュー", -1))
const _hoisted_20 = {
  class: "row-content inline-block",
  style: {"white-space":"pre-line"}
}
const _hoisted_21 = { class: "body-row flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "row-label inline-block" }, [
  /*#__PURE__*/_createTextVNode("オプション"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("メニュー")
], -1))
const _hoisted_23 = { class: "row-content inline-block ml-2" }
const _hoisted_24 = { class: "card-footer flex flex-column" }
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-clock" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "予約確認", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-user" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会員情報", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

import { onMounted, ref } from "vue";
/**
 * Vuexストア
 * アプリケーション全体の状態管理に使用
 */
import { useStore } from "vuex";
/**
 * VueUseユーティリティ
 * 日付フォーマットと値の取得に使用
 */
import { get, useDateFormat } from "@vueuse/core";
/**
 * 予約メッセージコンポーネント
 * 予約に関する通知メッセージの表示に使用
 */
import BookingMessage from "./BookingMessage.vue";
/**
 * HTTPクライアント
 * APIリクエストに使用
 */
import axios from "axios";
/**
 * PrimeVueの確認ダイアログ
 * 予約キャンセル時の確認に使用
 */
import { useConfirm } from "primevue/useconfirm";
/**
 * Vue Router
 * ルーティング情報の取得に使用
 */
import { useRoute } from "vue-router";
/**
 * ルーティング定数
 * 画面遷移先の定義に使用
 */
import RouterConstants from "@/customer/constants/router.constants";
/**
 * ルーティングユーティリティ
 * 画面遷移の制御に使用
 */
import RouterUtils from "@/common/utils/router.util";
/**
 * APIルーティング定数
 * APIエンドポイントの定義に使用
 */
import ApiRouterConstants from "../../common/constants/api.router.constants";
/**
 * 日付フォーマット定数
 * 日付表示形式の定義に使用
 */
import { DATE_FORMAT } from "@/clinic/typings/constants/booking";
/**
 * Vue Routerインスタンス
 * プログラムによる画面遷移に使用
 */
import router from "@/router";
/**
 * 日付操作ユーティリティ
 * 日付のフォーマットに使用
 */
import DateTimeUtils from "../utils/date-time-utils";
/**
 * 予約設定サービス
 * 予約設定の取得に使用
 */
import { BookingSettingService } from "@/customer/services";

/**
 * Vuexストアインスタンス
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingHistory',
  setup(__props) {

/**
 * 予約履歴画面コンポーネント
 * 現在の予約と過去の予約を表示し、予約の変更やキャンセルが可能
 * 予約一覧の表示、フィルタリング、予約操作（変更・キャンセル）を提供
 */

/**
 * Vueの基本機能
 * コンポーネントのライフサイクルとリアクティブな状態管理に使用
 */
const store = useStore();
/**
 * 現在のルート情報
 */
const route = useRoute();
/**
 * 確認ダイアログインスタンス
 */
const confirm = useConfirm();
/**
 * 予約一覧
 * @type {Ref<any[]>}
 */
let bookingList = ref();
/**
 * 現在の予約表示フラグ
 * @type {Ref<boolean>}
 */
let isIncomingBooking = ref(true);

/**
 * 予約のメニュー名を整形して返す
 * メインのメニュー名と追加メニュー名を結合
 * @param {any} booking - 予約情報
 * @returns {string} 整形されたメニュー名
 */
const medicalMenuNames = (booking: any) => {
  const medicalMenuName = booking.medical_menu?.name;
  const additionalMenuNames = booking.additional_menus?.map(menu => menu.name);
  return [medicalMenuName, ...additionalMenuNames].join("\n");
};

/**
 * コンポーネントのマウント時の処理
 * 現在の予約を表示し、予約設定を読み込む
 */
onMounted(async () => {
  handleClickFilter("incoming");
  const { data: settings } = await BookingSettingService.loadSetting(store.getters["line_account/clinicId"]);
  store.commit("bookingSetting/setBookingSetting", settings.value);
});

/**
 * 予約一覧のフィルタリング処理
 * 現在の予約または過去の予約を表示
 * @param {string} filterClass - フィルター種別（'incoming' または 'history'）
 */
const handleClickFilter = async (filterClass: string) => {
  const { clinic_id } = route.query;
  // APIから予約一覧を取得
  const res = await axios.get(ApiRouterConstants.API_BOOKING, {
    params: {
      clinic_id: clinic_id || store.getters["line_account/clinicId"],
      line_account_id: store.getters["line_account/id"],
      status: filterClass,
      sort_by: "start_time",
    },
    headers: { Accept: "application/json" },
  });
  // 表示フラグを更新
  if (filterClass == "history") {
    isIncomingBooking.value = false;
  } else {
    isIncomingBooking.value = true;
  }
  bookingList.value = res.data;
};

/**
 * 予約のキャンセル処理
 * 確認ダイアログを表示し、承認された場合にキャンセルを実行
 * @param {number} bookingId - キャンセルする予約のID
 */
const handleCancelBooking = (bookingId: number) => {
  confirm.require({
    message: "この予約をキャンセルしますか?",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "登録",
    accept: async () => {
      const { clinic_id } = route.query;
      // 予約キャンセルのAPIを呼び出し
      await axios.patch(
        `${ApiRouterConstants.API_BOOKING}/${bookingId}/cancel`,
        {
          clinic_id: clinic_id || store.getters["line_account/clinicId"],
          line_account_id: store.getters["line_account/id"],
        },
        { headers: { Accept: "application/json" } }
      );
      // 予約一覧を更新し、キャンセル完了画面に遷移
      handleClickFilter("incoming");
      router.push(`${RouterConstants.CUSTOMER_ROOT_PATH}/booking-cancel-success/${bookingId}`);
    },
  });
};

/**
 * 予約履歴画面への遷移
 * クリニックIDをクエリパラメータとして保持
 */
const goToBookingHistory = () => {
  const { clinic_id } = route.query;

  RouterUtils.goToWithQuery(RouterConstants.BOOKING_HISTORY_ROUTER_NAME, {
    clinic_id: clinic_id || store.getters["line_account/clinicId"],
  });
};

/**
 * 会員情報画面への遷移
 * クリニックIDをクエリパラメータとして保持
 */
const goToCustomerInfos = () => {
  const { clinic_id } = route.query;

  RouterUtils.goToWithQuery(RouterConstants.CUSTOMER_INFOS_ROUTER_NAME, {
    clinic_id: clinic_id || store.getters["line_account/clinicId"],
  });
};

/**
 * 予約変更画面への遷移
 * 選択された予約の情報をストアに保存し、メニュー選択画面に遷移
 * @param {number} bookingId - 変更する予約のID
 */
const handleUpdateBooking = (bookingId: number) => {
  const { clinic_id } = route.query;

  // 選択された予約の情報をストアに保存
  store.commit(
    "booking/setBookingParams",
    bookingList.value.find(booking => booking.id == bookingId)
  );

  // メニュー選択画面に遷移
  RouterUtils.goToWithQuery(RouterConstants.BOOKING_MENU_CATEGORY_ROUTER_NAME, {
    clinic_id: clinic_id || store.getters["line_account/clinicId"],
    edit: true,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(BookingMessage),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickFilter('incoming'))),
          class: _normalizeClass(["btn justify-content-center", _unref(isIncomingBooking) ? 'active-btn' : '']),
          type: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("現在の予約")
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClickFilter('history'))),
          class: _normalizeClass(["btn justify-content-center", !_unref(isIncomingBooking) ? 'active-btn' : '']),
          type: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("過去の予約")
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_unref(isIncomingBooking))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingList), (booking) => {
        return (_openBlock(), _createElementBlock("div", {
          key: booking,
          class: _normalizeClass(["col-12", { 'md:col-6 sm:col-12': _unref(isIncomingBooking), grid: !_unref(isIncomingBooking) }])
        }, [
          (_unref(isIncomingBooking))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    (booking.start_time)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(DateTimeUtils).formatDate(booking.start_time, booking.end_time)[0]), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, "承認待ち"))
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(medicalMenuNames(booking)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.medical_options, (option) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: option.id
                        }, _toDisplayString(option.name), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Button, {
                    class: "p-button-edit justify-content-center",
                    onClick: ($event: any) => (handleUpdateBooking(booking.id)),
                    disabled: !booking.can_cancel || !booking.status == 'will_come'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 日時変更をする ")
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  _createVNode(_component_Button, {
                    class: "p-button-cancel justify-content-center",
                    onClick: ($event: any) => (handleCancelBooking(booking.id)),
                    disabled: !booking.can_cancel || !booking.status == 'will_come'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" キャンセルする ")
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(get)(_unref(useDateFormat)(booking.start_time, _unref(DATE_FORMAT)))), 1),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(DateTimeUtils).formatDate(booking.start_time, booking.end_time)[1]), 1)
              ], 64))
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", { class: "fixed-bottom-menu flex justify-content-center" }, [
      _createElementVNode("div", {
        class: "btn-wrap flex flex-column justify-content-center align-items-center cursor-pointer",
        onClick: goToBookingHistory
      }, _hoisted_29),
      _createElementVNode("div", {
        class: "btn-wrap flex flex-column justify-content-center align-items-center cursor-pointer",
        onClick: goToCustomerInfos
      }, _hoisted_32)
    ])
  ]))
}
}

})